// Shared
import ECodificacao from '@/shared/enums/ECodificacao';

// Stores
import type { TMenuSibebar } from '@/stores/TemaStore';

// Public
import jsonMenus from '../../../assets/data/menus_dashboards.json';

// Routers
import { cTEMA_ESTOQUE_ROUTES } from '@/router/temas/rotasTemaEstoque';

const menusTemaEstoque = jsonMenus.temaEstoque;

const cMENUS_TEMA_ESTOQUE: TMenuSibebar[] = [
  {
    codificacao: ECodificacao.TemaEstoque,
    id: menusTemaEstoque.children.consumoDeMaterial.id,
    nameRoute: cTEMA_ESTOQUE_ROUTES.ConsumoDeMaterial.name,
    icone: menusTemaEstoque.children.consumoDeMaterial.icone,
    titulo: menusTemaEstoque.children.consumoDeMaterial.titulo,
    corIcone: menusTemaEstoque.children.consumoDeMaterial.corIcone,
  },

  {
    codificacao: ECodificacao.TemaEstoque,
    id: menusTemaEstoque.children.disponibilidadeEstoque.id,
    nameRoute: cTEMA_ESTOQUE_ROUTES.DisponibilidadeEstoque.name,
    icone: menusTemaEstoque.children.disponibilidadeEstoque.icone,
    titulo: menusTemaEstoque.children.disponibilidadeEstoque.titulo,
    corIcone: menusTemaEstoque.children.disponibilidadeEstoque.corIcone,
  },

  {
    codificacao: ECodificacao.TemaEstoque,
    id: menusTemaEstoque.children.estoqueMinimoMaximoCritico.id,
    nameRoute: cTEMA_ESTOQUE_ROUTES.EstoqueMinimoMaximoCritico.name,
    icone: menusTemaEstoque.children.estoqueMinimoMaximoCritico.icone,
    titulo: menusTemaEstoque.children.estoqueMinimoMaximoCritico.titulo,
    corIcone: menusTemaEstoque.children.estoqueMinimoMaximoCritico.corIcone,
  },

  {
    codificacao: ECodificacao.TemaEstoque,
    id: menusTemaEstoque.children.personalizado.id,
    icone: menusTemaEstoque.children.personalizado.icone,
    titulo: menusTemaEstoque.children.personalizado.titulo,
    corIcone: menusTemaEstoque.children.personalizado.corIcone,
    nameRoute: cTEMA_ESTOQUE_ROUTES.Personalizado.Gerenciador.name,
  },
] as const;

export default cMENUS_TEMA_ESTOQUE;
